var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmilePlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "110px",
    viewBox: "0 0 99 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.1349,
    height: 34.6741,
    fill: "black",
    fillOpacity: 0,
    transform: "translate(0.865112 0.953796)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.1349,
    height: 34.6741,
    fill: "black",
    fillOpacity: 0,
    transform: "translate(0.865112 0.953796)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2679 35.0819L24.7256 20.1286C25.8082 17.4867 27.489 17.4126 27.68 17.4134C28.7954 17.4296 30.3169 16.7847 32.4196 14.9237C32.57 14.7909 32.7221 14.6513 32.8789 14.506L33.0578 14.3372C35.8255 11.9252 38.6774 11.1016 40.7963 11.1016C44.0809 11.1016 45.9595 12.33 46.2199 15.2423C48.6639 12.4211 52.2027 11.1016 55.0774 11.1016C60.8721 11.1016 61.0697 15.0601 59.1598 20.2933L53.7629 35.0819H47.6486L52.7474 21.112C53.5441 18.9284 54.6733 15.8338 51.1604 15.8338C47.0993 15.8338 44.8364 20.657 43.7235 23.7065L39.5722 35.082H33.4584L38.5574 21.1122C39.3546 18.9285 40.4834 15.834 36.9699 15.834C32.9092 15.834 30.6475 20.6572 29.5341 23.7066L25.3822 35.0822H19.2679V35.0819Z",
    fill: "#011B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8451 35.0819L64.3976 11.6475H70.5114L61.9587 35.0819H55.8451Z",
    fill: "#011B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8822 11.5318C25.3793 11.6291 25.9221 11.7499 26.4987 11.9004L26.7746 11.9664C27.3196 12.1225 27.8988 12.2992 28.4962 12.5078C25.2086 16.3885 20.1364 15.6051 20.1364 15.6051L19.8135 15.5552H19.287C17.6184 15.5609 15.3882 16.1526 14.4816 18.1551C12.7925 21.8867 24.4953 19.5201 20.6638 27.9837C18.1917 33.4447 12.3213 35.628 7.34741 35.628C5.02083 35.628 2.83283 35.2192 0.865112 34.6274L2.68969 31.1559H8.28559C8.46064 31.1646 8.6388 31.1688 8.81896 31.1688C10.3698 31.1688 13.1018 30.5776 14.132 28.3022C16.2126 23.7065 4.1596 26.8455 7.9911 18.3823C10.277 13.3314 15.7126 11.1016 20.504 11.1016C22.3492 11.1016 23.6962 11.2896 24.8822 11.5318Z",
    fill: "#011B33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6361 0.953796L71.906 30.3539C70.0694 34.5998 65.3407 35.0375 64.4177 35.0828L64.0667 35.082L76.5221 0.953796H82.6361Z",
    fill: "#011B33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5697 21.0667H92.9728C93.8696 18.1091 93.4316 15.5609 90.0097 15.5609C86.5866 15.5609 83.9893 17.9271 82.5697 21.0667ZM85.5907 31.1688C85.7717 31.1688 85.953 31.1646 86.1341 31.1566H93.3966L92.4462 33.7622C89.7617 34.9911 86.9739 35.628 83.6889 35.628C75.9319 35.628 73.0427 31.1688 75.8493 23.4786C78.3239 16.6985 83.971 11.1016 91.2719 11.1016C99.9869 11.1016 100.275 17.0626 97.2857 25.2533H81.042C79.9371 29.0305 81.8027 31.1688 85.5907 31.1688Z",
    fill: "#011B33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0023 9.93682L66.4718 5.91031C66.7437 5.22255 67.4873 4.11163 70.6602 4.11163H73.2422L73.0506 4.63554C71.0032 9.91572 65.3442 9.93573 65.3442 9.93573L65.0023 9.93682Z",
    fill: "#022B50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilePlain);
export default __webpack_public_path__ + "static/media/Smile-Plain.3841e64a5ec371939949a020168dab8d.svg";
export { ForwardRef as ReactComponent };